"use client";

import { ILoggingService } from "@/services/logger/logging-service";
import React, { createContext, useContext } from "react";
import { ConsoleLoggingService } from "@/services/logger/console.logger";

const LoggingContext = createContext<ILoggingService | null>(null);

export const useLoggingContext = (): ILoggingService => {
  const context = useContext(LoggingContext);
  if (!context) {
    throw new Error("useLogging must be used within a LoggingProvider");
  }
  return context;
};

const LoggingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const loggingService = ConsoleLoggingService.getInstance();

  return (
    <LoggingContext.Provider value={loggingService}>
      {children}
    </LoggingContext.Provider>
  );
};

export default LoggingProvider;
